module.exports = __webpack_public_path__ + "img/clean.cadef1a2.png";